export const requestSchema = async (
  payload: DerivePayload
): Promise<SchemaResponse> => {
  try {
    const response = await fetch(`${process.env.PUBLIC_URL}/derive`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw Error();
    return response.json();
  } catch {
    throw Error('Failed fetching schema');
  }
};

export const requestMetrics = async (
  payload: CalculateSizePayload
): Promise<Metrics> => {
  try {
    const response = await fetch(`${process.env.PUBLIC_URL}/calculateSize`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!response.ok) throw Error();
    return response.json();
  } catch {
    throw Error('Failed fetching metrics');
  }
};
